import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = ["innerHTML"];
var _hoisted_2 = ["innerHTML"];
var _hoisted_3 = ["innerHTML"];
var _hoisted_4 = ["innerHTML"];
var _hoisted_5 = {
  class: "tw-flex sm:tw-items-center tw-content-between tw-pt-10px tw-flex-col sm:tw-flex-row tw-gap-10px"
};
var _hoisted_6 = ["innerHTML"];
var _hoisted_7 = {
  class: "tw-flex tw-items-center tw-content-between tw-pt-5px"
};
var _hoisted_8 = ["innerHTML"];
var _hoisted_9 = ["innerHTML"];
var _hoisted_10 = {
  class: "tw-mx-0 tw-pt-10px tw-pb-15px"
};
var _hoisted_11 = ["innerHTML"];
var _hoisted_12 = ["innerHTML"];
var _hoisted_13 = ["innerHTML"];
var _hoisted_14 = ["innerHTML"];
var _hoisted_15 = ["innerHTML"];
var _hoisted_16 = ["innerHTML"];
var _hoisted_17 = ["innerHTML"];
var _hoisted_18 = {
  key: 2,
  class: "tw-flex tw-flex-wrap tw-mb-20px tw-text-12"
};
var _hoisted_19 = ["innerHTML"];
var _hoisted_20 = ["innerHTML"];
var _hoisted_21 = {
  key: 3,
  class: "tw-flex tw-items-center tw-pb-20px"
};
var _hoisted_22 = ["src"];
var _hoisted_23 = ["innerHTML"];
var _hoisted_24 = ["innerHTML"];
var _hoisted_25 = ["innerHTML"];
var _hoisted_26 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_BaseInput = _resolveComponent("BaseInput");
  var _component_base_complex_toggle = _resolveComponent("base-complex-toggle");
  var _component_base_button = _resolveComponent("base-button");
  var _component_base_badge = _resolveComponent("base-badge");
  var _component_BaseBtModal = _resolveComponent("BaseBtModal");
  var _component_success_modal = _resolveComponent("success-modal");
  var _component_save_search_success_modal = _resolveComponent("save-search-success-modal");
  var _component_limit_modal = _resolveComponent("limit-modal");
  var _component_unauthorized_modal = _resolveComponent("unauthorized-modal");
  var _component_limit_saved_modal = _resolveComponent("limit-saved-modal");
  return _ctx.errorCode === -1 ? (_openBlock(), _createBlock(_component_BaseBtModal, {
    key: 0,
    id: "save-search-modal",
    ref: "saveSearchModal",
    "data-cy": "save-search-modal",
    "custom-modal-dialog-classes": "modal-md",
    "custom-modal-header-classes": "tw-p-0 tw-sticky tw-top-0 !tw-py-15px tw-z-10 tw-bg-white",
    "custom-modal-body-classes": "tw-pb-20px tw-flex tw-flex-col",
    "custom-modal-footer-classes": "tw-sticky tw-bottom-0 tw-m-0 tw-flex tw-justify-center !tw-pt-0",
    "close-icon-btn-classes": "!tw-top-10px",
    "show-modal": _ctx.show,
    "with-close-icon": true,
    "with-custom-footer": true,
    "header-title": _ctx.labels.activate_save_search,
    onClosed: _ctx.closedModal
  }, {
    body: _withCtx(() => [_createElementVNode("span", {
      class: "tw-text tw-font-regular",
      innerHTML: _ctx.labels.saveSearchNotification
    }, null, 8 /* PROPS */, _hoisted_1), _ctx.isLoggedWithoutConfirmedMail ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createElementVNode("p", {
      class: "tw-text tw-mb-40px",
      innerHTML: _ctx.labels.not_verified
    }, null, 8 /* PROPS */, _hoisted_2), _createElementVNode("span", {
      innerHTML: _ctx.labels.not_received_email
    }, null, 8 /* PROPS */, _hoisted_3), _createElementVNode("span", {
      innerHTML: _ctx.labels.click_button_below
    }, null, 8 /* PROPS */, _hoisted_4)], 64 /* STABLE_FRAGMENT */)) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createCommentVNode(" Mobile email "), !_ctx.isUserLogged ? (_openBlock(), _createBlock(_component_BaseInput, {
      key: 0,
      id: "email",
      modelValue: _ctx.requestData.email,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.requestData.email = $event),
      class: "tw-block sm:tw-hidden",
      "input-class": "tw-text tw-font-regular",
      type: "email",
      "label-text": "Email",
      "is-valid": _ctx.isValid(_ctx.v$.requestData.email),
      feedback: {
        valid: '',
        invalid: 'Inserisci una email valida'
      }
    }, null, 8 /* PROPS */, ["modelValue", "is-valid"])) : _createCommentVNode("v-if", true), _createVNode(_component_BaseInput, {
      id: "title",
      modelValue: _ctx.requestData.title,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.requestData.title = $event),
      class: "tw-mt-20px",
      "input-class": "tw-text tw-font-regular",
      "label-text": _ctx.labels.titleLabel,
      type: "text"
    }, null, 8 /* PROPS */, ["modelValue", "label-text"]), _createCommentVNode("  Desktop email"), !_ctx.isUserLogged ? (_openBlock(), _createBlock(_component_BaseInput, {
      key: 1,
      id: "email",
      modelValue: _ctx.requestData.email,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.requestData.email = $event),
      class: "tw-hidden sm:tw-block tw-mt-20px",
      "input-class": "tw-text tw-font-regular",
      type: "email",
      "label-text": "Email",
      "is-valid": _ctx.isValid(_ctx.v$.requestData.email),
      feedback: {
        valid: '',
        invalid: 'Inserisci una email valida'
      }
    }, null, 8 /* PROPS */, ["modelValue", "is-valid"])) : _createCommentVNode("v-if", true), _createElementVNode("div", _hoisted_5, [_createElementVNode("p", {
      class: "tw-my-10px sm:tw-my-0 tw-inline-block tw-text-16 tw-font-semibold",
      innerHTML: _ctx.labels.choose_typology_saved_search
    }, null, 8 /* PROPS */, _hoisted_6), _createVNode(_component_base_complex_toggle, {
      modelValue: _ctx.alertType,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.alertType = $event),
      class: "tw-mx-auto",
      type: "padded",
      mode: "mobile",
      labels: {
        leftToggle: {
          label: _ctx.labels.alertHourly
        },
        rightToggle: {
          label: _ctx.labels.alertDaily,
          checked: _ctx.requestData.dailyAlert
        }
      }
    }, null, 8 /* PROPS */, ["modelValue", "labels"])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("p", {
      class: "tw-text-16 tw-font-semibold tw-my-10px",
      innerHTML: _ctx.labels.filters
    }, null, 8 /* PROPS */, _hoisted_8), _ctx.type === 'listing' ? (_openBlock(), _createBlock(_component_base_button, {
      key: 0,
      "btn-class": "tw-btn-show-more tw-pr-0",
      onClick: _cache[4] || (_cache[4] = $event => _ctx.isAuction ? _ctx.setShowModal(_ctx.Modals.filtersAuctionModal) : _ctx.setShowModal(_ctx.Modals.filtersModal))
    }, {
      default: _withCtx(() => [_createElementVNode("span", {
        class: "tw-text sm:tw-text-12 tw-font-semibold",
        innerHTML: _ctx.labels.modifyFilters
      }, null, 8 /* PROPS */, _hoisted_9)]),
      _: 1 /* STABLE */
    })) : _createCommentVNode("v-if", true)]), _createCommentVNode(" Map "), _createElementVNode("div", {
      id: "save-search-modal-map",
      class: "tw-h-[100px] tw-w-full tw-bg-center tw-bg-cover tw-bg-no-repeat tw-rounded tw-border tw-border-solid tw-border-w-lavender",
      style: _normalizeStyle({
        backgroundImage: _ctx.mapURL
      })
    }, null, 4 /* STYLE */), _createElementVNode("div", _hoisted_10, [_createCommentVNode(" First chip: placeName "), _createVNode(_component_base_badge, {
      "badge-class": "tw-badge-outline-tag",
      class: "tw-mr-2 tw-mb-10px"
    }, {
      default: _withCtx(() => {
        var _a;
        return [!_ctx.place ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          innerHTML: _ctx.labels.mapAreaDrawn
        }, null, 8 /* PROPS */, _hoisted_11)) : _ctx.place.placeType == _ctx.placeType.CITY && !_ctx.isArrNullOrEmpty(_ctx.realEstateSearchBean.zoneIdList) ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: "tw-text tw-font-regular",
          innerHTML: "".concat(_ctx.place ? _ctx.place.cityName : '', "  - ").concat((_a = _ctx.realEstateSearchBean.zoneIdList) === null || _a === void 0 ? void 0 : _a.length, " ").concat(_ctx.labels.zones)
        }, null, 8 /* PROPS */, _hoisted_12)) : (_openBlock(), _createElementBlock("span", {
          key: 2,
          class: "tw-text tw-font-regular",
          innerHTML: _ctx.place.displayName
        }, null, 8 /* PROPS */, _hoisted_13))];
      }),
      _: 1 /* STABLE */
    }), _createCommentVNode(" Second chip: typology "), _createVNode(_component_base_badge, {
      "badge-class": "tw-badge-outline-tag",
      class: "tw-mr-2 tw-mb-10px"
    }, {
      default: _withCtx(() => [_createElementVNode("span", {
        class: "tw-font-regular tw-capitalize",
        innerHTML: "".concat(_ctx.currentTypologyLabel)
      }, null, 8 /* PROPS */, _hoisted_14)]),
      _: 1 /* STABLE */
    }), _createCommentVNode(" Third chip: contract "), _createVNode(_component_base_badge, {
      "badge-class": "tw-badge-outline-tag",
      class: "tw-mr-2 tw-mb-10px"
    }, {
      default: _withCtx(() => [_createElementVNode("span", {
        class: "tw-text tw-font-regular",
        innerHTML: _ctx.labels.contract_type
      }, null, 8 /* PROPS */, _hoisted_15)]),
      _: 1 /* STABLE */
    }), _createCommentVNode(" Fourth chip: filter counter"), _ctx.filterLabelsAndCounter.filterLabels[0] ? (_openBlock(), _createBlock(_component_base_badge, {
      key: 0,
      "badge-class": "tw-badge-outline-tag",
      class: "tw-mr-2 tw-mb-10px"
    }, {
      default: _withCtx(() => [_createElementVNode("span", {
        class: "tw-text tw-font-regular",
        innerHTML: _ctx.filterLabelsAndCounter.filterLabels[0]
      }, null, 8 /* PROPS */, _hoisted_16)]),
      _: 1 /* STABLE */
    })) : _createCommentVNode("v-if", true), _createCommentVNode(" Fifth chip: Filters counter "), _ctx.filterLabelsAndCounter.filterCounter ? (_openBlock(), _createBlock(_component_base_badge, {
      key: 1,
      "badge-class": "tw-badge-outline-tag",
      class: "tw-mr-2 tw-mb-10px"
    }, {
      default: _withCtx(() => [_createElementVNode("span", {
        class: "tw-text tw-font-regular",
        innerHTML: "+ ".concat(_ctx.filterLabelsAndCounter.filterCounter)
      }, null, 8 /* PROPS */, _hoisted_17)]),
      _: 1 /* STABLE */
    })) : _createCommentVNode("v-if", true)]), _createCommentVNode(" Privacy section "), !_ctx.isUserLogged ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("span", {
      innerHTML: _ctx.readAndAcceptedByClicking
    }, null, 8 /* PROPS */, _hoisted_19), _createElementVNode("a", {
      href: "/privacy",
      class: "tw-underline",
      onClick: _cache[5] || (_cache[5] = _withModifiers(
      //@ts-ignore
      function () {
        return _ctx.openPrivacyDisclaimer && _ctx.openPrivacyDisclaimer(...arguments);
      }, ["prevent"])),
      innerHTML: _ctx.labels.privacy_policy_generic
    }, null, 8 /* PROPS */, _hoisted_20)])) : !_ctx.enableNotifications && !_ctx.isiOSDevice() ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("img", {
      src: "".concat(_ctx.cdn, "/_ui/img/Ico/info-gray.svg"),
      alt: "info icon",
      height: "18",
      width: "18",
      class: "tw-mr-10px"
    }, null, 8 /* PROPS */, _hoisted_22), _ctx.isUserLogged ? (_openBlock(), _createElementBlock("p", {
      key: 0,
      class: "tw-inline-block tw-m-0 tw-text-12 tw-font-regular",
      innerHTML: _ctx.labels.enable_browser_notifications
    }, null, 8 /* PROPS */, _hoisted_23)) : _createCommentVNode("v-if", true)])) : _createCommentVNode("v-if", true), _ctx.showErrorMessage ? (_openBlock(), _createElementBlock("div", {
      key: 4,
      class: "tw-text-right tw-text-w-danger tw-mr-15px tw-my-5px",
      innerHTML: _ctx.labels.description
    }, null, 8 /* PROPS */, _hoisted_24)) : _createCommentVNode("v-if", true)], 64 /* STABLE_FRAGMENT */))]),
    footer: _withCtx(() => [!_ctx.isLoggedWithoutConfirmedMail ? (_openBlock(), _createBlock(_component_base_button, {
      key: 0,
      id: "ssm-submit",
      "btn-class": "tw-w-full tw-btn-w-primary sm:tw-w-auto",
      type: "submit",
      disabled: _ctx.isUserLogged && !_ctx.email,
      "is-loading": _ctx.isLoading,
      onClick: _cache[6] || (_cache[6] = $event => _ctx.enterPressedCb && _ctx.enterPressedCb())
    }, {
      default: _withCtx(() => [_createElementVNode("span", {
        innerHTML: _ctx.labels.confirm
      }, null, 8 /* PROPS */, _hoisted_25)]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["disabled", "is-loading"])) : (_openBlock(), _createBlock(_component_base_button, {
      key: 1,
      id: "confirm-email-btn",
      class: "tw-btn-w-primary tw-self-center",
      "is-loading": _ctx.isLoading,
      onClick: _ctx.onConfirmEmailBtt
    }, {
      default: _withCtx(() => [_createElementVNode("span", {
        innerHTML: _ctx.labels.send_verify
      }, null, 8 /* PROPS */, _hoisted_26)]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["is-loading", "onClick"]))]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show-modal", "header-title", "onClosed"])) : _ctx.errorCode === 200 && _ctx.realEstateSearchBean.polygonFromMap ? (_openBlock(), _createBlock(_component_success_modal, {
    key: 1,
    "show-modal": true,
    labels: {
      title: _ctx.labels.successModalTitle,
      description1: _ctx.labels.description1,
      description2_1: _ctx.labels.description2_1,
      description2_2: _ctx.labels.description2_2,
      confirm_link: _ctx.labels.confirm_link,
      description_no_logged: _ctx.labels.description_no_logged
    },
    "is-logged": _ctx.isUserLogged,
    "is-mail-confirmed": !!_ctx.mailConfirmed,
    onClosed: _ctx.closedModal
  }, null, 8 /* PROPS */, ["labels", "is-logged", "is-mail-confirmed", "onClosed"])) : _ctx.errorCode === 200 && !_ctx.realEstateSearchBean.polygonFromMap ? (_openBlock(), _createBlock(_component_save_search_success_modal, {
    key: 2,
    "show-modal": true,
    labels: {
      genericConfirm: _ctx.labels.confirm
    },
    email: _ctx.requestData.email,
    name: _ctx.name,
    "public-user-id": _ctx.publicUserId,
    "is-user-logged": _ctx.isUserLogged,
    "page-name": _ctx.pageName,
    "real-estate-search-bean": _ctx.realEstateSearchBean,
    onClosed: _ctx.closedModal
  }, null, 8 /* PROPS */, ["labels", "email", "name", "public-user-id", "is-user-logged", "page-name", "real-estate-search-bean", "onClosed"])) : _ctx.errorCode === 412 ? (_openBlock(), _createBlock(_component_limit_modal, {
    key: 3,
    "show-modal": true,
    labels: {
      title: _ctx.labels.limitModalTitle,
      reached_limit: _ctx.labels.reached_limit,
      sign_in: _ctx.labels.sign_in
    },
    onClosed: _ctx.closedModal,
    onOpenSigninModal: _ctx.openSignInModal
  }, null, 8 /* PROPS */, ["labels", "onClosed", "onOpenSigninModal"])) : _ctx.errorCode === 401 ? (_openBlock(), _createBlock(_component_unauthorized_modal, {
    key: 4,
    "show-modal": true,
    labels: {
      title: _ctx.labels.unauthorizedTitle,
      unauthorized: _ctx.labels.unauthorized,
      login: _ctx.labels.login
    },
    onClosed: _ctx.closedModal,
    onOpenLoginModal: _ctx.showLoginModal
  }, null, 8 /* PROPS */, ["labels", "onClosed", "onOpenLoginModal"])) : _ctx.errorCode === 405 || _ctx.errorCode === 409 ? (_openBlock(), _createBlock(_component_limit_saved_modal, {
    key: 5,
    "show-modal": true,
    labels: {
      title: _ctx.labels.generic_error,
      limit_saved: _ctx.errorCode === 405 ? _ctx.labels.limit_saved_not_logged : _ctx.labels.limit_saved_logged
    },
    onClosed: _ctx.closedModal
  }, null, 8 /* PROPS */, ["labels", "onClosed"])) : _createCommentVNode("v-if", true);
}